import type {SaleMode} from '@app/service/user-preferences.service';
import type {ShortcutMenu} from '@app/domain/shortcut-menu';

export function accesoVentaAlternativa(mode: SaleMode | null) {
    return mode === 'POS'
        ? {label: 'Venta tradicional', icon: 'pi pi-file-edit', routerLink: ['/ventas/nueva-venta'],
            queryParams: {tradicional: '1', alternativa: '1'}}
        : {label: 'Venta POS', icon: 'pi pi-bolt', routerLink: ['/ventas/pos'], queryParams: {alternativa: '1'}};
}

/** The exported menu remains a template: permission/visibility and personal choices belong to each rendered copy. */
export function menuConModalidad(items: any[], mode: SaleMode | null): any[] {
    return items.map(item => ({...item,
        ...(item.rol && {rol: [...item.rol]}),
        ...(Array.isArray(item.routerLink) && {routerLink: [...item.routerLink]}),
        ...(item.queryParams && {queryParams: {...item.queryParams}}),
        ...(item.items && {items: menuConModalidad(item.items, mode)}),
        ...(item.ventaAlternativa && accesoVentaAlternativa(mode))
    }));
}

/** Canonical saved route identifies the alternative slot; its id/roles/company record are never rewritten. */
export function shortcutConModalidad(item: ShortcutMenu, mode: SaleMode | null): ShortcutMenu {
    if (item.ruta !== '/ventas/pos') { return {...item}; }
    const alternative = accesoVentaAlternativa(mode);
    return {...item, nombre: alternative.label, icono: alternative.icon,
        ruta: alternative.routerLink[0], queryParams: alternative.queryParams};
}
